import { render, staticRenderFns } from "./ContentCategory.vue?vue&type=template&id=8d660582&scoped=true"
import script from "./ContentCategory.vue?vue&type=script&lang=js"
export * from "./ContentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d660582",
  null
  
)

export default component.exports